let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("3ColL")).then(() => parcelRequire('YVOUf'));